/** @velyn-custom BEGIN — vely-announcement-bar.js
 *  Mobile-only slider for sections/vely-announcement-bar.liquid:
 *  slide 1 = countdown, slide 2 = promo items. Auto-slides every 5s and has
 *  small prev/next chevrons. Swiper is only alive at <= 767.98px.
 */
(function () {
  const MOBILE_QUERY = "(max-width: 767.98px)";
  const getSwiper = () => window.Swiper;

  class VelyAnnouncementSlider extends HTMLElement {
    connectedCallback() {
      if (this._velyAbInitStarted) return;
      this._velyAbInitStarted = true;
      this._mq = window.matchMedia(MOBILE_QUERY);
      this._onMqChange = () => this.sync();
      this._mq.addEventListener("change", this._onMqChange);
      this.waitForSwiper(() => this.sync());
    }

    disconnectedCallback() {
      this._mq?.removeEventListener("change", this._onMqChange);
      this._mq = null;
      this._onMqChange = null;
      this.destroySwiper();
      this._velyAbInitStarted = false;
    }

    waitForSwiper(callback, attempt = 0) {
      if (typeof getSwiper() === "function") {
        callback();
        return;
      }
      if (attempt > 80) {
        console.warn("[vely-announcement-bar] Swiper not available");
        return;
      }
      setTimeout(() => this.waitForSwiper(callback, attempt + 1), 50);
    }

    sync() {
      if (this._mq?.matches) {
        if (!this._swiper) this.init();
      } else {
        this.destroySwiper();
      }
    }

    destroySwiper() {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }

    init() {
      const SwiperCtor = getSwiper();
      const swiperEl = this.querySelector(".vely-announcement-bar__swiper");
      if (typeof SwiperCtor !== "function" || !swiperEl) return;

      const delay = Number(this.dataset.autoplayDelay) || 5000;
      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      try {
        this._swiper = new SwiperCtor(swiperEl, {
          slidesPerView: 1,
          speed: 400,
          rewind: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoplay: reduceMotion
            ? false
            : { delay, disableOnInteraction: false },
          navigation: {
            prevEl: this.querySelector(".vely-announcement-bar__nav--prev"),
            nextEl: this.querySelector(".vely-announcement-bar__nav--next"),
          },
        });
      } catch (error) {
        this._swiper = null;
        console.warn("[vely-announcement-bar] Swiper init failed", error);
      }
    }
  }

  if (!customElements.get("vely-announcement-slider")) {
    customElements.define("vely-announcement-slider", VelyAnnouncementSlider);
  }

  document.addEventListener("shopify:section:load", (event) => {
    const host = event.target?.querySelector?.("vely-announcement-slider");
    if (host) {
      host._velyAbInitStarted = false;
      host.connectedCallback();
    }
  });
})();
/** @velyn-custom END — vely-announcement-bar.js */
